export default __webpack_public_path__ + "static/706-455a227eeeb2f11ff0aa382c07f4c2a1.gif";